<template >
    <div class="restore__container">
        <img :src="images.logo" alt="Логотип" class="restore__logo">
        <div class="restore__form-box" v-if="!restore">
            <h2 class="restore__title">Восстановление пароля</h2>
            <form method="post" class="restore__form">
                <input-component v-model:meaning="volume.identity" @input="errors.identity = ''" inputType="text" inputName="email" inputContent="admin" inputLabel="Логин или e-mail" :inputError="errors.identity" required />
                <div class="restore__button-box">
                    <button-component buttonText="Восстановить пароль" class="restore__button" @click.prevent="forgotPassword"/>
                    <router-link :to="{name:'login'}" class="restore__link">Вернуться ко входу</router-link>
                </div>
            </form>
        </div>
        <div class="restore__text-box" v-else>
            <p class="restore__text">Заявка на восстановление пароля отправлена на электронную почту <b>{{volume.identity}}</b></p>
            <router-link :to="{name:'login'}" class="restore__link restore__link_back">Вернуться ко входу</router-link>
        </div>
    </div>
</template>
<script setup lang="ts">
import logo from '../assets/img/svg/logo.svg'
import InputComponent from '../shared/Form/Input/InputComponent.vue'
import buttonComponent from '../shared/buttonComponent.vue'
import toast from '../app/lib/hooks/errorToast'
import axios from '../app/lib/api'
import { ref } from 'vue'
import { forgotPasswordShema } from '../app/lib/shemas/updateUserShema'

const images = {
    logo: logo
}
const volume= ref({
    identity: ''
})
const errors =ref({
    identity: ''
})
const restore = ref(false)

async function forgotPassword() {
    try {
        await forgotPasswordShema.validate(volume.value, { abortEarly: false })
        errors.value = {
            identity: ''
        }
        try {
            const res = await axios.auth.forgotPassword(volume.value)
            toast('success', res.data.message)
            restore.value = true
        } catch (error: any) {
            toast('error', error.response.data.message)
            error.response.data.errors?.forEach((item: any) => toast('error', item.message))
        }
    } catch (error: any) {
        // @ts-ignore
        error.inner.forEach((error) => {
            // @ts-ignore
            errors.value[error.path] = error.message;
        });
    }
}
</script>